<template>
  <v-btn block :color="buttonColor" @click="onAbsentClicked" class="white--text">
    <slot name="confirmText" v-if="buttonState">
      Confirmar
    </slot>
    <slot v-else />
  </v-btn>
</template>

<script>
export default {
  name: 'mutable-button',

  data: () => ({
    buttonState: false
  }),

  props: {
    actionColor: {
      type: String,
      default: 'primary'
    },
    confirmColor: {
      type: String,
      default: 'danger'
    },
    timeout: {
      type: Number,
      default: 3000
    }
  },

  methods: {
    onAbsentClicked () {
      if (this.buttonState) {
        this.buttonState = false
        this.$emit('confirm')
      } else {
        this.buttonState = true
        setTimeout(() => {
          this.buttonState = false
        }, this.timeout)
      }
    }
  },
  computed: {
    buttonColor () {
      return this.buttonState ? this.confirmColor : this.actionColor
    }
  }
}
</script>
